<template>
  <div>
    <base-select
      v-model="shareMethodsSelectedIndex"
      :items="shareMethodsLabels"
      label="Select a method to share"
      @on-search="search = $event"
    />
  </div>
</template>

<script>
export const [TEXT, WECHAT, EMBED] = [...Array(3).keys()];
export const METHODS = [{
  name: 'Text',
  actionLabel: 'Create Link',
  successTitle: 'Done!',
  successText: 'Your link has been copied to clipboard.',
  id: TEXT,
}, {
  name: 'WeChat',
  actionLabel: 'Download',
  successTitle: 'QR code downloaded!',
  successText: 'Your QR Code has been downloaded for WeChat.',
  id: WECHAT,
},
{
  name: 'Embed Code',
  actionLabel: 'Create Embed Code',
  successTitle: 'Copy Embed Code',
  successText: 'Here is a preview. Click the button below to copy your embed code.',
  id: EMBED,
}];

export default {
  name: 'LinkShareMethodSelector',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    sharedLinkSelector: {
      type: Boolean,
      default: false,
    },
    disabledMethods: {
      type: Array,
      /** Method has to exist in METHODS */
      validator: (methods) => methods.every((method) => METHODS.map((m) => m.id).includes(method)),
      default: () => [],
    },
  },
  data() {
    return {
      search: '',
      shareMethodsSelectedIndex: null,
    };
  },
  computed: {
    shareMethodsLabels() {
      return this.shareMethods.map((i) => i.name);
    },
    selected() {
      return this.value;
    },
    shareMethods() {
      let l = METHODS
        .filter((item) => (this.search.length ? item.name.toLowerCase().includes(this.search.toLowerCase()) : true));
      if (!this.useFeature('embed_code_enabled')) {
        l = l.filter((item) => item.id !== EMBED);
      }
      return l;
    },
  },
  watch: {
    shareMethodsSelectedIndex(value) {
      this.$emit('input', this.shareMethods[value]);
    },
    search(newval) {
      this.$emit('search', newval);
    },
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
</style>
